import { render, staticRenderFns } from "./pdfPreviewBtn.vue?vue&type=template&id=c67d8454&scoped=true"
import script from "./pdfPreviewBtn.vue?vue&type=script&lang=js"
export * from "./pdfPreviewBtn.vue?vue&type=script&lang=js"
import style0 from "./pdfPreviewBtn.vue?vue&type=style&index=0&id=c67d8454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67d8454",
  null
  
)

export default component.exports